module.exports = __webpack_public_path__ + "img/immobilizer.762eac86.svg";